import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/lib/api';

const SeasonContext = createContext({ seasonOpen: true, activeSeason: null, loading: true, refresh: () => {} });

export function SeasonProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [activeSeason, setActiveSeason] = useState(null);
  const [seasonOpen, setSeasonOpen] = useState(true);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const r = await api.get('/api/seasons');
      const active = r.data.find(s => s.status === 'active');
      setActiveSeason(active || null);
      setSeasonOpen(!!active);
    } catch {
      setSeasonOpen(true);
      setActiveSeason(null);
    }
    setLoading(false);
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) refresh();
  }, [isAuthenticated, refresh]);

  return (
    <SeasonContext.Provider value={{ seasonOpen, activeSeason, loading, refresh }}>
      {children}
    </SeasonContext.Provider>
  );
}

export const useSeason = () => useContext(SeasonContext);
